/* Progressive enhancement only: Shopify owns submission, CAPTCHA and success. */
(() => {
  if (customElements.get('adverpack-free-bags')) return;

  class AdverpackFreeBags extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const form = this.querySelector('form');
      if (!form) return;

      // Native required/min/step/email checks also work without this script.
      // Reject whitespace-only required text without changing Shopify's POST.
      form.addEventListener('input', (event) => {
        if (typeof event.target.setCustomValidity === 'function') {
          event.target.setCustomValidity('');
        }
      }, { signal });

      form.addEventListener('submit', (event) => {
        for (const field of form.querySelectorAll('input[required], textarea[required]')) {
          field.setCustomValidity(field.value.trim() ? '' : 'Please complete this field.');
        }
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
        }
        // No fetch, mailto, local success flag or disabled CAPTCHA submit button.
        // A valid request continues through the native Shopify contact form.
      }, { signal });

      const status = this.querySelector('[data-ap-free-status]');
      if (status && !this.hasAttribute('data-design-mode')) {
        this.focusFrame = requestAnimationFrame(() => {
          status.focus({ preventScroll: true });
          status.scrollIntoView({ block: 'center', behavior: 'auto' });
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.focusFrame);
    }
  }

  customElements.define('adverpack-free-bags', AdverpackFreeBags);
})();
